import React, { useEffect, useRef, useState } from "react";
import useGetDashboard from "../../../../hooks/useGetDashboard";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import Loading from "../../../../components/Loading/Loading";
import localeText from "../../../../locale";
import { formatPrice } from "../../../../utilities/formatPrice";
import { Chart } from "primereact/chart";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import AdminService from "../../../../service/AdminService";
import PhysicalStoreService from "../../../../service/PhysicalStoreService";
import { Toast } from "primereact/toast";
import useBankTransfers from "../../../../hooks/useGetBankTransfers";
import { useHistory } from "react-router-dom";

const formatDate = (date) => {
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  if (month < 10) month = "0" + month;

  let day = date.getDate();
  if (day < 10) day = "0" + day;

  return [year, month, day].join("-");
};

const AdminBackofficeHome = () => {
  const history = useHistory();
  const { showErrorToast } = useToastContext();
  const [filter, setFilter] = useState({
    dateBegin: "2000-01-01",
    dateEnd: "",
    filter: false,
    selectedId: 0,
  });

  useBankTransfers({
    onBankTransferError: (code) => showErrorToast({ code }),
    onSuccess: (transfers) => {
      if (transfers && transfers.length > 0) {
        toast?.current?.show({
          severity: "success",
          sticky: true,
          content: () => (
            <div className="flex flex-column align-items-left" style={{ flex: "1" }}>
              <div className="flex align-items-center gap-2">
                <span className="font-bold text-900">{localeText("youHavePendingUsers")}</span>
              </div>
              <div className="font-medium my-3 text-900">
                {localeText("seeYourPendingUsersBankTransfer")}
              </div>
              <Button
                className="p-button-sm flex"
                label={localeText("usersPendings")}
                severity="success"
                onClick={(e) => {
                  e.preventDefault();
                  history.push("/dashboard-banktransfers");
                  toast.current.clear();
                }}
              ></Button>
            </div>
          ),
        });
      }
    },
  });

  const [dateBeginCalendar, setDateBeginCalendar] = useState(new Date("2000-01-01"));
  const [dateEndCalendar, setDateEndCalendar] = useState(new Date());

  const toast = useRef(null);

  const { dashboardData, isLoading } = useGetDashboard({
    onError: (code) => showErrorToast({ code }),
    filter: filter,
  });
  const [chartData1, setChartData1] = useState({});
  const [chartOptions1, setChartOptions1] = useState({});

  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  const adminService = new AdminService();
  const physicalStoreService = new PhysicalStoreService();

  useEffect(() => {
    async function getPendingOrders() {
      try {
        const res = await adminService.getPendingOrders(
          localStorage.getItem("__extraconomy_token")
        );
        if (res.result.length) {
          toast?.current?.show({
            severity: "success",
            sticky: true,
            content: () => (
              <div className="flex flex-column align-items-left" style={{ flex: "1" }}>
                <div className="flex align-items-center gap-2">
                  <span className="font-bold text-900">{localeText("youHavePendingOrders")}</span>
                </div>
                <div className="font-medium my-3 text-900">
                  {localeText("seeYourPendingOrders")}
                </div>
                <Button
                  className="p-button-sm flex"
                  label={localeText("pendings")}
                  severity="success"
                  onClick={(e) => {
                    e.preventDefault();
                    history.push("/dashboard-pendings");
                    toast.current.clear();
                  }}
                ></Button>
              </div>
            ),
          });
        }
      } catch (error) {
        console.log(error);
      }
    }

    getPendingOrders(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getPedingWithdraws = async () => {
      const res = await adminService.getAllWithdrawRequests(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );

      const pendingWithdraws = res.result.filter((withdraw) => withdraw.status === "PROCESSING");

      if (pendingWithdraws.length > 0) {
        toast?.current?.show({
          severity: "success",
          sticky: true,
          content: () => (
            <div className="flex flex-column align-items-left" style={{ flex: "1" }}>
              <div className="flex align-items-center gap-2">
                <span className="font-bold text-900">{localeText("youHavePendingWithdraws")}</span>
              </div>
              <div className="font-medium my-3 text-900">
                {localeText("seeYourPendingWithdraws")}
              </div>
              <Button
                className="p-button-sm flex"
                label={localeText("withdrawPendings")}
                severity="success"
                onClick={(e) => {
                  e.preventDefault();
                  history.push("/dashboard-listwithdrawrequests");
                  toast.current.clear();
                }}
              ></Button>
            </div>
          ),
        });
      }
    };

    getPedingWithdraws(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dashboardData) {
      const total =
        dashboardData.amountManagers +
        dashboardData.amountSellers +
        dashboardData.amountPartners +
        dashboardData.amountCustomers +
        dashboardData.amountPromoters;
      const data = {
        labels: [
          `Manager (${dashboardData.amountManagers})`,
          `Seller (${dashboardData.amountSellers})`,
          `Partner (${dashboardData.amountPartners})`,
          `Customer (${dashboardData.amountCustomers})`,
          `Promoter (${dashboardData.amountPromoters})`,
          `Total (${total})`,
        ],
        datasets: [
          {
            label: localeText("usersOfSystem"),
            data: [
              dashboardData.amountManagers,
              dashboardData.amountSellers,
              dashboardData.amountPartners,
              dashboardData.amountCustomers,
              dashboardData.amountPromoters,
              total,
            ],
            backgroundColor: ["#272360", "#46a748", "#f7b005", "#42A5F5", "rgb(156, 39, 176)"],
          },
        ],
      };
      const options = {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            display: true,
            title: {
              display: true,
              text: localeText("users"),
            },
          },
          y: {
            display: true,
            title: {
              display: true,
              text: localeText("quantity"),
              beginAtZero: true,
            },
          },
        },
      };

      setChartData1(data);
      setChartOptions1(options);
    }
  }, [dashboardData]);

  useEffect(() => {
    if (dashboardData) {
      const data = {
        labels: [
          `${localeText("productsNotPublished")} (${dashboardData.amountUnpublishedProducts})`,
          `${localeText("archivedProducts")} (${dashboardData.amountArchievedProducts})`,
          `${localeText("productsPublished")} (${dashboardData.amountPublishedProducts})`,
        ],
        datasets: [
          {
            label: localeText("productsOfSystem"),
            data: [
              dashboardData.amountUnpublishedProducts,
              dashboardData.amountArchievedProducts,
              dashboardData.amountPublishedProducts,
            ],
            backgroundColor: ["#272360", "#46a748", "#f7b005"],
          },
        ],
      };
      const options = {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom",
          },
        },
      };

      setChartData(data);
      setChartOptions(options);
    }
  }, [dashboardData]);

  useEffect(() => {
    async function fetchBangoodRequests() {
      try {
        const res = await adminService.getBangoodRequests(
          localStorage.getItem("__extraconomy_token")
        );

        if (
          res.messageCode === 200001 &&
          res.result.filter((item) => item.status_order_banggood === "NOT PROCESSED").length > 0
        ) {
          toast?.current?.show({
            severity: "success",
            sticky: true,
            content: () => (
              <div className="flex flex-column align-items-left" style={{ flex: "1" }}>
                <div className="flex align-items-center gap-2">
                  <span className="font-bold text-900">
                    {localeText("youHaveUnprocessedOrders")}
                  </span>
                </div>
                <div className="font-medium my-3 text-900">
                  {localeText("pendingBangoodOrders")}
                </div>
                <Button
                  className="p-button-sm flex"
                  label={localeText("pendings")}
                  severity="success"
                  onClick={(e) => {
                    e.preventDefault();
                    history.push("/dashboard-bangood");
                    toast.current.clear();
                  }}
                ></Button>
              </div>
            ),
          });
        }
      } catch (e) {
        console.log(e);
      }
    }

    fetchBangoodRequests(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function fetchPendingPhysicalStores() {
      try {
        const res = await physicalStoreService.getPendingVerifications();
        if (res.messageCode === 200001 && res.result?.length > 0) {
          toast?.current?.show({
            severity: "success",
            sticky: true,
            content: () => (
              <div className="flex flex-column align-items-left" style={{ flex: "1" }}>
                <div className="flex align-items-center gap-2">
                  <span className="font-bold text-900">
                    {localeText("youHavePendingPhysicalStores")}
                  </span>
                </div>
                <div className="font-medium my-3 text-900">
                  {localeText("seeYourPendingPhysicalStores")}
                </div>
                <Button
                  className="p-button-sm flex"
                  label={localeText("physicalStoresPending")}
                  severity="success"
                  onClick={(e) => {
                    e.preventDefault();
                    history.push("/dashboard-listphysicalstores");
                    toast.current.clear();
                  }}
                />
              </div>
            ),
          });
        }
      } catch (e) {
        console.log(e);
      }
    }

    fetchPendingPhysicalStores(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filters = [
    {
      id: 0,
      label: localeText("all"),
      onClick: () => {
        const date = new Date();
        setDateBeginCalendar(new Date(new Date("2000-01-01").toISOString()));
        setDateEndCalendar(new Date(date.toISOString()));

        setFilter({
          dateBegin: "2000-01-01",
          dateEnd: "",
          filter: false,
          selectedId: 0,
        });
      },
    },
    {
      id: 1,
      label: `30 ${localeText("days")}`,
      onClick: () => {
        const date = new Date();
        const dateBegin = formatDate(new Date(date.setDate(date.getDate() - 30)));
        const dateEnd = formatDate(new Date());

        setDateBeginCalendar(new Date(new Date(dateBegin).toISOString()));
        setDateEndCalendar(new Date(new Date(dateEnd).toISOString()));

        setFilter({
          dateBegin: dateBegin,
          dateEnd: dateEnd,
          filter: true,
          selectedId: 1,
        });
      },
    },
    {
      id: 2,
      label: `7 ${localeText("days")}`,
      onClick: () => {
        const date = new Date();
        const dateBegin = formatDate(new Date(date.setDate(date.getDate() - 7)));
        const dateEnd = formatDate(new Date());

        setDateBeginCalendar(new Date(new Date(dateBegin).toISOString()));
        setDateEndCalendar(new Date(new Date(dateEnd).toISOString()));

        setFilter({
          dateBegin: dateBegin,
          dateEnd: dateEnd,
          filter: true,
          selectedId: 2,
        });
      },
    },
  ];

  return (
    <div>
      <div style={{ padding: "7px" }}>
        <Toast ref={toast} position="bottom-center" />
        <h1 className="text-2xl font-bold">{localeText("dashboard")}</h1>

        <div>
          <h5>{localeText("filters")}</h5>

          <div className="flex align-items-center gap-2 mb-4">
            {filters.map((item, index) => (
              <Button
                key={item.id}
                className={`${filter.selectedId === index ? "bg-green-800" : ""}`}
                label={item.label}
                onClick={item.onClick}
              />
            ))}
          </div>

          <div className="flex gap-2 align-items-center">
            <label htmlFor="dateBegin">{localeText("from")}</label>
            <Calendar
              className="w-full lg:w-auto md:w-auto"
              value={dateBeginCalendar}
              onChange={(e) => {
                setDateBeginCalendar(e.value);
                setFilter((prev) => ({ ...prev, dateBegin: formatDate(e.value), filter: true }));
              }}
              dateFormat="dd/mm/yy"
            />
            <label htmlFor="dateEnd">{localeText("toFrom")}</label>
            <Calendar
              className="w-full lg:w-auto md:w-auto"
              value={dateEndCalendar}
              onChange={(e) => {
                setDateEndCalendar(e.value);
                setFilter((prev) => ({ ...prev, dateEnd: formatDate(e.value), filter: true }));
              }}
              dateFormat="dd/mm/yy"
            />
          </div>
        </div>
      </div>

      {isLoading ? (
        <Loading classNameIcon={"text-4xl"} />
      ) : (
        <div>
          <div className={`flex flex-wrap layout-dashboard`}>
            <div className="md:w-4 col w-full" style={{ minWidth: "320px" }}>
              <div className="overview-box views h-full">
                <span className="overview-title">
                  <b>{localeText("salesRevenue")}</b>
                </span>
                <i className="overview-icon pi pi-dollar"></i>
                <div className="overview-numbers">
                  <ul className="list-none p-0">
                    <li>
                      <div className="flex">
                        EUR {formatPrice(dashboardData.amountRevenueSales)}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="md:w-4 col w-full" style={{ minWidth: "320px" }}>
              <div className="overview-box checkin h-full">
                <span className="overview-title">
                  <b>{localeText("feeRevenue")}</b>
                </span>
                <i className="overview-icon pi pi-wallet"></i>
                <div className="overview-numbers">
                  <ul className="list-none p-0">
                    <li>
                      <div className="flex">
                        EUR {formatPrice(dashboardData.amountPlatformTaxesRetained)}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="md:w-4 col w-full" style={{ minWidth: "320px" }}>
              <div className="overview-box users h-full">
                <i className="overview-icon pi pi-cart-plus"></i>
                <span className="overview-title">
                  <b>{localeText("registeredStores")}</b>
                </span>
                <div className="overview-numbers">
                  <ul className="list-none p-0 mb-0">
                    <li>{dashboardData.amountStoresRegistered}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap layout-dashboard">
            <div className="md:w-4 col w-full" style={{ minWidth: "320px" }}>
              <div className="overview-box h-full" style={{ backgroundColor: "rgb(156, 39, 176)" }}>
                <i className="overview-icon pi pi-box"></i>
                <span className="overview-title">
                  <b>{localeText("completedOrders")}</b>
                </span>
                <div className="overview-numbers">
                  <ul className="list-none p-0 mb-0">
                    <li>{dashboardData.amountFinishedOrders}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="md:w-4 col w-full" style={{ minWidth: "320px" }}>
              <div className="overview-box sales h-full">
                <div className="flex align-items-start gap-2 justify-content-between">
                  <span className="overview-title">
                    <b>{localeText("revenueFromUserRegistration")}</b>
                  </span>
                  <i className="overview-icon pi pi-money-bill"></i>
                </div>
                <div className="overview-numbers">
                  <ul className="list-none p-0 mb-0">
                    <li>EUR {formatPrice(dashboardData.amountRevenueRegister)}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="md:w-4 col w-full" style={{ minWidth: "320px" }}>
              <div
                className="overview-box sales h-full"
                style={{ backgroundColor: "rgb(156, 39, 176)" }}
              >
                <div className="flex align-items-start gap-2 justify-content-between">
                  <span className="overview-title">
                    <b>{localeText("quantityOfWithdrawsCompleted")}</b>
                  </span>
                  <i className="overview-icon pi pi-box"></i>
                </div>
                <div className="overview-numbers">
                  <ul className="list-none p-0 mb-0">
                    <li>{dashboardData.totalWithdrawCompleted}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap layout-dashboard">
            <div className="md:w-4 col w-full" style={{ minWidth: "320px" }}>
              <div className="overview-box views h-full">
                <div className="flex align-items-start gap-2 justify-content-between">
                  <span className="overview-title">
                    <b>{localeText("totalAmountWithdrawsCompleted")}</b>
                  </span>
                  <i className="overview-icon pi pi-money-bill"></i>
                </div>
                <div className="overview-numbers">
                  <ul className="list-none p-0 mb-0">
                    <li>EUR {formatPrice(dashboardData.amountWithdrawCompleted)}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="md:w-4 col w-full" style={{ minWidth: "320px" }}>
              <div className="overview-box checkin h-full">
                <div className="flex align-items-start gap-2 justify-content-between">
                  <span className="overview-title">
                    <b>{localeText("totalOfUsersPublishedAds")}</b>
                  </span>
                  <i className="overview-icon pi pi-box"></i>
                </div>
                <div className="overview-numbers">
                  <ul className="list-none p-0 mb-0">
                    <li>{dashboardData.totalUserPublished}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="md:w-4 col w-full" style={{ minWidth: "320px" }}>
              <div className="overview-box users h-full">
                <i className="overview-icon pi pi-money-bill"></i>
                <span className="overview-title">
                  <b>{localeText("totalofCommissionsPaid")}</b>
                </span>
                <div className="overview-numbers">
                  <ul className="list-none p-0 mb-0">
                    <li>EUR {formatPrice(dashboardData.amountComissions)}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="grid mt-3 align-items-start" style={{ padding: ".5rem" }}>
            <div className="col-12 lg:col-9">
              <div className="card card-w-title statistics p-5">
                <h4 className="lg:text-xl text-md">{localeText("usersOfSystem")}</h4>
                <Chart type="bar" data={chartData1} options={chartOptions1} />
              </div>
            </div>

            <div className="col-12 lg:col-3">
              <div className="card card-w-title statistics p-5">
                <div>
                  <h4 className="lg:text-xl text-md">{localeText("productsOfSystem")}</h4>
                  <Chart type="doughnut" data={chartData} options={chartOptions} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminBackofficeHome;
